import React, { useEffect, useState } from 'react';
import { Modal, Button, Alert } from 'react-bootstrap';
import MotivoRimborsoFields, { motivoRimborsoCompleto } from './MotivoRimborsoFields';
import RimborsoMiraklInfo from './RimborsoMiraklInfo';

// Chiede il motivo prima di impostare Rimborsato su un ordine (cambio stato rapido dalla lista)
function MotivoRimborsoModal({ ordine, messaggio, onClose, onConfirm }) {
  const [motivo, setMotivo] = useState({ motivo_rimborso: '', note_rimborso: '' });

  useEffect(() => {
    if (ordine) setMotivo({ motivo_rimborso: ordine.motivo_rimborso || '', note_rimborso: ordine.note_rimborso || '' });
  }, [ordine]);

  return (
    <Modal show={!!ordine} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Rimborso ordine #{ordine?.id}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {messaggio && <Alert variant="warning" className="small">{messaggio}</Alert>}
        <RimborsoMiraklInfo ordineId={ordine?.id} />
        <MotivoRimborsoFields value={motivo} onChange={setMotivo} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Annulla</Button>
        <Button variant="dark" disabled={!motivoRimborsoCompleto(motivo)} onClick={() => onConfirm(motivo)}>
          Conferma rimborso
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MotivoRimborsoModal;
